import React, { useState } from "react"
import {
  Card,
  Grid,
  Button,
  Typography,
  TextField,
  Switch,
  Chip,
  makeStyles,
} from "@material-ui/core"
import LocationOnIcon from "@material-ui/icons/LocationOn"
import { useTranslation } from "react-i18next"
import _ from "lodash"
import * as QA_Automation from "@qaAutomation"

let multiChipKitTestId = QA_Automation?.doAddOnTestIdCommonMultiChipKit

const useStyles = makeStyles((theme) => ({
  textInput: {
    "& .MuiOutlinedInput-root.Mui-focused .MuiOutlinedInput-notchedOutline": {
      borderColor: "var(--primaryColor)",
    },
    "& .MuiFormHelperText-contained": {
      textAlign: "end",
      color: `${(props) =>
        props?.defaultValue?.length === props?.maxLength
          ? "inherit"
          : "#df86bb"}`,
      fontSize: "12px",
      marginRight: "0px",
      fontStyle: "italic",
      fontWeight: "400",
    },
  },
  chip: {
    "& .MuiChip-deleteIcon": {
      color: "var(--primaryColor)",
    },
  },
}))

const CustomTextField = (props) => {
  const classes = useStyles()
  const {
    renderAdditional = () => "",
    isError = false,
    errorMessage = "IS_REQUIRED",
    title="",
    ...restProps
  } = props || {}
  return (
    <Grid style={{ minHeight: 60, position: "relative" }}>
      <TextField {...restProps} className={classes.textInput} />
      {renderAdditional()}
      {isError && (
        <Typography style={{ color: "red", fontSize: 12 }} {...multiChipKitTestId(`${title}-error`)}>
          {errorMessage}
        </Typography>
      )}
    </Grid>
  )
}

const MultiChipKit = (props) => {
  const { t } = useTranslation()
  const classes = useStyles()
  const {
    onUpdate = () => "",
    errorMsg = "",
    idList = [],
    placeholder = "",
    inputProps = {},
    maxLength = "",
    minLength = 3,
    limits = 14,
    type = "1",
    title = ""
  } = props || {}
  let decLimit = limits - 1

  const [selectedIdList, setSelectedIdList] = useState(idList || [])
  const [txtValue, setTxtValue] = useState("")
  let checkDuplicate =
    selectedIdList?.filter((itm) => itm === txtValue) || false

  let checks =
    txtValue?.length === 0 ||
    checkDuplicate.length < 0 ||
    txtValue?.length <= decLimit

  return (
    <Grid
      item
      xs={12}
      sm={6}
      md={6}
      lg={5}
      style={{ marginLeft: "50px", marginTop: "10px" }}
    >
      <Grid style={{ position: "relative", width: "100%" }}>
        <Button
         {...multiChipKitTestId(`${title}-plus-icon`)}
          disabled={checks}
          onClick={() => {
            let updateLit = _.cloneDeep(selectedIdList)
            if (updateLit?.includes(txtValue)) {
              return false
            } else {
              updateLit?.push(txtValue)
              setTxtValue("")
            }
            setSelectedIdList(updateLit)
            onUpdate(updateLit)
          }}
          style={{
            background: checks ? "grey" : "#df86bb",
            color: "white",
            position: "absolute",
            zIndex: "9",
            right: "0",
            minWidth: 37,
            width: 37,
            height: 37,
            fontSize: 24,
          }}
        >
          +
        </Button>
        <CustomTextField
          title = {title}
          className="cls-statuscode-ui-txt"
          name="name"
          // value={txtValue}
          style={{ width: "100%", fontStyle: "italic" }}
          variant="outlined"
          size="small"
          helperText={
            type === "1"
              ? `${t("REMAINING")}: ${limits - (txtValue?.length || 0)}`
              : `${t("REMAINING")}: ${
                  Math.sign(limits - (txtValue?.length || 0)) === -1
                    ? maxLength - (txtValue?.length || 0) //+ "/" + maxLength
                    : limits - (txtValue?.length || 0) // + "/" + limits
                }`
          }
          placeholder={t(placeholder)}
          isError={checkDuplicate?.length > 0 || errorMsg !== ""}
          inputProps={{
            ...multiChipKitTestId(`${title}-input`),
            maxLength: maxLength,
            minLength: minLength,
          }}
          errorMessage={
            errorMsg
              ? t(errorMsg)
              : checkDuplicate?.length > 0 &&
                t("DEVICE_ID_CODE_ALREADY_PRESENT")
          }
          onChange={(event) => {
            setTxtValue(event.target.value?.replace(/(\s{2,})/g, " "))
          }}
          defaultValue={txtValue}
          maxLength={maxLength}
          minLength={minLength}
          renderAdditional={() => {
            return (
              <>
                {type === "2" ? (
                  <Grid
                    style={{
                      position: "absolute",
                      left: 0,
                      top: 43,
                      fontSize: 12,
                      color: "#868686",
                      fontStyle: "italic",
                    }}
                  >
                    {`${t('MINIMUM')}: ${minLength}, ${t('MAXIMUM')}: ${maxLength}`}
                  </Grid>
                ) : (
                  <></>
                )}
              </>
            )
          }}
        />
      </Grid>

      {selectedIdList?.length > 0 && (
        <Grid
          style={{
            width: "100%",
            minHeight: "unset",
            borderRadius: 8,
            marginTop: "15px",
          }}
        >
          {selectedIdList?.length > 0 ? (
            selectedIdList?.map((item, index) => {
              return (
                <Chip
                  {...multiChipKitTestId(`${title}-${item}-input-label`)}
                  label={item}
                  className={classes.chip}
                  variant="default"
                  style={{
                    fontWeight: "bold",
                    background: "#ffffff",
                    border: "1px solid var(--primaryColor)",
                    borderRadius: 50,
                    marginRight: 5,
                    marginBottom: 5,
                  }}
                  onDelete={(e) => {
                    let updateLit = _.cloneDeep(selectedIdList)
                    _.remove(updateLit, (x) => x === item)
                    console.log(updateLit, "delete")
                    setSelectedIdList(updateLit)
                    onUpdate(updateLit)
                  }}
                />
              )
            })
          ) : (
            <span {...multiChipKitTestId(`${title}-add-device-id-error`)}>{t("PLEASE_ADD_THE_DEVICE_ID")}</span>
          )}
        </Grid>
      )}
    </Grid>
  )
}

export { MultiChipKit }
export default MultiChipKit
